import AppHeader from "@/components/AppHeader";

export default {
  name: "master-phrase-edit",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.getPhrase();
  },
  data() {
    return {
      phrase: {
        company_id: "",
        template_text: ""
      },
      companies: "",
      getCompaniesEnd: false,
      getPhraseEnd: false
    };
  },
  computed: {
    authorityCheckNotUseCompany() {
      if (
        localStorage.user_authority == 3 ||
        localStorage.user_authority == 4
      ) {
        // 総務部でログイン
        return true;
      }
      return false;
    }
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompaniesEnd = true;
    },
    async getPhrase() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_PHRASE", {
          id: this.$route.params.phrase_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.phrase.company_id = res.phrase.company_id;
      this.phrase.template_text = res.phrase.template_text;
      this.getPhraseEnd = true;
    },
    async editPhrase() {
      let data = this.phrase;
      let res = await this.$store
        .dispatch("EDIT_PHRASE", {
          id: this.$route.params.phrase_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.$router.push({ path: "/master_phrase" });
      }
    },
    goMasterPhrase() {
      this.$router.push({ path: "/master_phrase" });
    }
  }
};
